"use client";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { urlMaker } from "services/url-maker";

import orderValues from "mock/order-values";

import { setMapOrListingFinalPath } from "src/helpers/map/commons";
import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import Dropdown from "components/common/dropdown";
import Unit from "@/src/utils/constants/units";

import styles from "./styles.module.css";

const OrderDropdown = ({ screenType, criteria, handleOrderDropdownChangeWithHistoryPush }) => {
  const orderValue = orderValues.orderValue;
  const selectedOption = orderValue.find((item) => item.key === criteria?.order?.orderType);
  
  const [placeHolder, setPlaceHolder] = useState(selectedOption?.value || "");

  const handleChangeDropdown = async (e) => {
    Ga4WithEventParameters({
      eventName: "sort_by",
      eventParameters: { label: `click||${e.ga4Label}` },
    });

    const defaultOrderKey = 1;
    const newCriteria = {
      ...criteria,
      order: {
        key: "order",
        orderType: e?.key || defaultOrderKey,
      },
    };

    const criteriaResponse = await urlMaker(newCriteria, "default");

    const url = setMapOrListingFinalPath({ res: criteriaResponse, screenType });

    if (screenType === "map") {
      window.history.pushState({}, document.title, url);
      handleOrderDropdownChangeWithHistoryPush(url);
      return;
    }
    window.location.href = url;
  };

  useEffect(() => {
    const filterSelectedOrder = renderMenuItems(criteria?.category?.category?.name)?.find(
      (item) => item?.key === criteria?.order?.orderType
    );
    setPlaceHolder(filterSelectedOrder?.value);
  }, [criteria]);

  const renderMenuItems = (category) => {
    const filterOrderValue = orderValue.filter(
      (item) => item.value !== `${Unit.M2.name} fiyatı azalan` && item.value !== `${Unit.M2.name} fiyatı artan`
    );

    return category === "Arsa" && screenType !== "map" ? orderValue : filterOrderValue;
  };

  return (
    <div className={styles.wrapper}>
      <Dropdown
        placeHolder={placeHolder}
        onChange={(e) => handleChangeDropdown(e)}
        placeHolderClass={styles.placeholder}
        options={renderMenuItems(criteria?.category?.category?.name)}
        listClass={styles.listBoxClass}
      />
    </div>
  );
};

OrderDropdown.propTypes = {
  criteria: PropTypes.object,
  screenType: PropTypes.string,
  handleOrderDropdownChangeWithHistoryPush: PropTypes.func,
};

export default OrderDropdown;
